import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import {ApiService} from "../api.service";

@Component({
    selector: 'app-lost-password',
    templateUrl: './lost-password.component.html',
    styleUrls: ['./lost-password.component.sass']
})
export class LostPasswordComponent implements OnInit {
    form = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email])
    });


    constructor(private apiService: ApiService, private router : Router) { }

    ngOnInit() {}
    onSubmit() {
        if(!this.form.valid) {
            return;
        };
        console.log("Send Request");
        this.apiService.lostPassword(this.form.value.email).subscribe(this.handleResponse);
    }

    handleResponse = (resp) => {
        if(resp) {
            this.router.navigate([{outlets: {modal: 'resetPassword'}}]);
        }
    }

}
